import type { FaireProductEntity } from "../../entity_types/product";

export const p_gws2r6e8za: FaireProductEntity = {
  token: "p_gws2r6e8za",
  type: "product",
  name: "Ishani Printed Kaftan Dresses - Multiple Prints",
  brandToken: "b_97986a72",
  brandName: "Sevya Handmade",
  imageUrl:
    "https://cdn.faire.com/fastly/7419ac393776dbb08772a36e536ddc40978734f34c1b366ffb62fa1c0c3139af.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/042251d0762cff6cbfb07802bcddfde6867c8877f46d77ec52c264b665098e00.jpeg",
    "https://cdn.faire.com/fastly/8e8261ec0762be7114080a0c47cadb82d7426dd368d0045c0e8c68f079b2eb7c.jpeg",
    "https://cdn.faire.com/fastly/0a8cec8fbc27babbe3ec6218e9b71614b966a97105c43a7920eb58fd9766ebf4.jpeg",
    "https://cdn.faire.com/fastly/c3e0d80b07ce5aed2bcd66af14874fa037547e4441633d5d455229e40ce0f513.jpeg",
    "https://cdn.faire.com/fastly/9dbbd56e142912413c9a6199d4189b085a50f5be8f6b94b1dc26bc494905b460.jpeg",
    "https://cdn.faire.com/fastly/e776287c3fd11b4965cafde8c52e1e4fd677de00136dfb574ec591a1e5feddde.jpeg",
    "https://cdn.faire.com/fastly/8e8258e7c7fd5918e29bd6feb0110e6a41ede58a41a720bbf60ede512a40de1e.jpeg",
    "https://cdn.faire.com/fastly/cc5f3987826cfd10d8944d89966b96bcf683e4e3e470fc3f0131df2252d9f287.jpeg",
    "https://cdn.faire.com/fastly/e47759163c5016f2a1fb0ffa0d2c15f33238a7ece19a8d7e9282e05f77badf96.jpeg",
    "https://cdn.faire.com/fastly/f88247960871582dde33308499f4368b3b440dcf915bfed04fdd6b9b601762e9.jpeg",
    "https://cdn.faire.com/fastly/76ca3b93e8b8bd4e76944c36a768dae85284b09b7ffa04dedc96d25b28d2d9ca.jpeg",
    "https://cdn.faire.com/fastly/3c4f747052f8248fd2414838740f1904699e5495c551b2ad0a996c585f90b78b.jpeg",
    "https://cdn.faire.com/fastly/e1353bb001a883194be1a3a015793044fc17447103f88e43d233dcefab149ec4.jpeg",
    "https://cdn.faire.com/fastly/83ac43950cfe7f6dc58894715aafba4068a4d5e2a54260df1cbb4380de914f6c.jpeg",
    "https://cdn.faire.com/fastly/d8db4731611225e1621085676282d00598b70c75c29d3f6b180720a0b3aa9270.jpeg",
    "https://cdn.faire.com/fastly/036f1748a45be28b4fa50321e56751f0d57c9c53d895de4a80efacab2fda9443.jpeg",
    "https://cdn.faire.com/fastly/f8cfffb49f645269cb71edf71e218363fc44ab955a578eb05aabf9bc2cd48c66.jpeg",
    "https://cdn.faire.com/fastly/460c3c17902a4b0d8f73731330a7df261d5f396b8cfa3d9e068c83b2634d4b54.jpeg",
    "https://cdn.faire.com/fastly/91dfff67bb2d6dc59f3b3484180ef7a8cb99ee33bf1ed0bb501f34e566e1c831.jpeg",
    "https://cdn.faire.com/fastly/9c750378c7e8f3435956b869630e3cf730dd207dae2b07d99263bfef970934ad.jpeg",
    "https://cdn.faire.com/fastly/21bef87c90bce94b609c47669960b31a28ab320235cecfb8759d1a0e1836dbb9.jpeg",
    "https://cdn.faire.com/fastly/0598240a697ba38297aa16167edc50e0b9ddcd69ce82e83d0552e71178e1427b.jpeg",
    "https://cdn.faire.com/fastly/2cecb556eb9301faf63b370370c17e48b8b95ee63238bdc9aa5d9a324d09b81e.jpeg",
    "https://cdn.faire.com/fastly/53194accc9884667507303dca4f1264774b04681ac6f339c362e4e345082abc1.jpeg",
    "https://cdn.faire.com/fastly/3dfd55e1148994b6ab0b0b6968c3559827ee5c6711845b5253157843747b3d53.jpeg",
    "https://cdn.faire.com/fastly/3c6275dad5245448e8f4e5c6ca10d8dbe627c4b36c65c02525c891830b95a72d.jpeg",
    "https://cdn.faire.com/fastly/75956945d3bb5007aadbd3f41e0a1a025cb3652288e570c716e31eca40e765e4.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "Our Ishani Kaftan is printed on soft 100% cotton material by artisans in Rajasthan, India. Designed for comfort and functionality with a box pleat, pockets and side slits, our caftans are made with high quality cotton material that India is famous for. \n\nThese comfortable fair trade caftans come in a range of beautiful prints and colors, and are available in two sizes S/M and L/XL.\n\n--------------------------\n\nMeasurements:\n\nS/M Size: \n• Bust: 42 inches around (107 centimeters)\n• Length: 50 inches (127 centimeters)\n\nL/XL Size: \n• Bust: 46 inches around (117 centimeters)\n• Length: 51 inches (130 centimeters)\n\n--------------------------------\n\n• Material: 100% Cotton\n\n• Care: Machine Wash in Cold Water, Tumble Dry Low Heat\n\n--------------------------\n",
  tags: [],
  msrpDollars: 59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:35.847Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
